module.exports = (__webpack_require__(7))(317);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/rxjs/add/observable/fromEvent.js from dll-reference vendor
// module id = 1227
// module chunks = 0